import React, { useState } from "react";

import { Grid } from "@material-ui/core";

import {
  TableColumnConfiguration,
  TablePaginationOptions
} from "../../../components/layout/table/types";
import Table from "../../../components/layout/table";

import { TopPurchasedProduct } from "../../../models/User";
import List from "../../../components/layout/list";

import { Top20TableProps } from "./types";
import useStyles from "./styles";

const Top20Collection = ({ products, screenSize }: Top20TableProps) => {
  const styles = useStyles();

  const [currentPage, setCurrentPage] = useState<number>(0);

  const rowsPerPage = screenSize === "desktop" ? 10 : 5;

  const paginationOptions: TablePaginationOptions = {
    count: products.length,
    page: currentPage,
    onPageChange: (event, page) => setCurrentPage(page),
    rowsPerPage
  };

  const columnConfiguration: TableColumnConfiguration<TopPurchasedProduct>[] = [
    {
      name: "Product",
      renderItem: product => product.productName
    },
    {
      name: "Nr of purchases",
      renderItem: product => product.count
    }
  ];

  const renderProductListItem = (product: TopPurchasedProduct) => (
    <div className={styles.productListItem}>
      <Grid container>
        <Grid item xs={6} className={styles.productListItemHeader}>
          Product name
        </Grid>
        <Grid item xs={6} className={styles.productListItemHeader}>
          No of purchases
        </Grid>

        <Grid item xs={6}>
          {product.productName}
        </Grid>
        <Grid item xs={6}>
          {product.count}
        </Grid>
      </Grid>
    </div>
  );

  const paginationStartIndex = currentPage * rowsPerPage;
  const paginationEndIndex = Math.min(
    (currentPage + 1) * rowsPerPage,
    products.length
  );

  return screenSize === "desktop" ? (
    <Table
      columns={columnConfiguration}
      data={products.slice(paginationStartIndex, paginationEndIndex)}
      keyExtractor={product => product.productName}
      paginationOptions={paginationOptions}
    />
  ) : (
    <List
      items={products.slice(paginationStartIndex, paginationEndIndex)}
      renderItem={renderProductListItem}
      keyExtractor={product => product.productName}
      paginationOptions={paginationOptions}
    />
  );
};

export default Top20Collection;
